export default {
  MAX_NUMBER_OF_TAGS: 5,
}
